module.exports = __webpack_public_path__ + "static/first_user_image2-0cc451a483ebc536b60e8a82f5f78f35.jpg";